export default defineAppConfig({
  ui: {
    primary: "emerald",
    gray: "zinc",
    notifications: {
      // Show toasts at the top right of the screen
      position: "top-0 bottom-auto",
    },
    alert: {
      description: "leading-5",
    },
    button: {
      base: "color-scheme-transition",
      color: {
        white: {
          solid: "dark:bg-[#1c1c1e]",
        },
      },
    },
    card: {
      base: "color-scheme-transition",
      background: "dark:bg-[#1c1c1e]",
    },
    formGroup: {
      help: "text-xs text-gray-500 dark:text-gray-400 mt-1",
    },
    input: {
      color: {
        white: {
          outline: "dark:bg-[#1c1c1e]",
        },
      },
    },
    select: {
      color: {
        white: {
          outline: "dark:bg-[#1c1c1e]",
        },
      },
    },
    checkbox: {
      background: "dark:bg-[#1c1c1e]",
    },
    pagination: {
      firstButton: {
        class: "dark:bg-[#1c1c1e]",
      },
      lastButton: {
        class: "dark:bg-[#1c1c1e]",
      },
      prevButton: {
        class: "dark:bg-[#1c1c1e]",
      },
      nextButton: {
        class: "dark:bg-[#1c1c1e]",
      },
    },
    avatar: {
      background: "dark:bg-[#1c1c1e]",
      wrapper: "ring-1 ring-gray-300 dark:ring-gray-700",
    },
    modal: {
      inner: "pb-safe",
      background: "dark:bg-[#1c1c1e]",
      overlay: {
        background: "dark:bg-[#0e0e0e]/75",
      },
    },
    slideover: {
      background: "dark:bg-[#1c1c1e]",
    },
    tabs: {
      list: {
        background:
          "bg-white dark:bg-[#1c1c1e] ring-1 ring-gray-200 dark:ring-gray-800",
        marker: {
          background: "bg-[#f3f4f7] dark:bg-[#323235]",
        },
      },
    },
  },
});
